import { render } from "./pagarcuenta.vue?vue&type=template&id=5c6b2f1a&scoped=true"
import script from "./pagarcuenta.vue?vue&type=script&lang=js"
export * from "./pagarcuenta.vue?vue&type=script&lang=js"

import "./pagarcuenta.vue?vue&type=style&index=0&id=5c6b2f1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6b2f1a"]])

export default __exports__